import React from 'react'
import { makeStyles } from "@material-ui/core";

// import logoKSR from "../../../assets/image/logo-ksr-white.png";
import logoKSR from "../../../assets/image/logo-ksr-white-medium.png";
// import logoKSR from "../../../assets/image/logo-ksr-color.png";
// import logoKSR from "../../../assets/image/logo-ksr-color-medium.png";

const useStyles = makeStyles(() => ({
  image: {
    width: "100vw",
    height: "100vh",
    backgroundImage: `url(${logoKSR})`,
    backgroundRepeat: "repeat",
    backgroundPosition: "100px",
    position: "fixed",
    zIndex: "-1",
    opacity: "0.2"
  }
}))

const BackgroundPattern = () => {
  const classes = useStyles();
  return (
    <section id="background-image" className={classes.image} style={{zIndex: "-100"}}></section>
  )
}

export default BackgroundPattern
